import React, { useState } from "react";
import { Helmet } from "react-helmet";

import FancyFeatureTewentyTwo from "../../../components/features/FancyFeatureTewentyTwo";


import FancyFeatureTen from "../../../components/features/FancyFeatureTen";
import HeaderThree from "../../../components/header/HeaderThree";
import CoreComponentProduct from "../../../assets/Sub-component/CoreComponentProduct";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import { Link } from "react-router-dom";

import Comprehensive_Support from '../../../assets/Services/Clash_empire/Emphasis_on_feature/Comprehensive_Support.svg'
import Flexible_Licensing_Options from '../../../assets/Services/Clash_empire/Emphasis_on_feature/Flexible_Licensing_Options.svg'
import Guilds_and_Alliances from '../../../assets/Services/Clash_empire/Emphasis_on_feature/Guilds_and_Alliances.svg'
import Player_profiles_and_customization from '../../../assets/Services/Clash_empire/Emphasis_on_feature/Player_profiles_and_customization.svg'
import Leaderboards_and_Rankings from '../../../assets/Services/Clash_empire/Emphasis_on_feature/Leaderboards_and_Rankings.svg'
import White_Label_Solutions from '../../../assets/Services/Clash_empire/Emphasis_on_feature/White_Label_Solutions.svg'

import Forging_Alliances from '../../../assets/Services/Clash_empire/Game_exp/Forging_Alliances.svg'
import Epic_Battles from '../../../assets/Services/Clash_empire/Game_exp/Epic_Battles.svg'
import Global_Competition from '../../../assets/Services/Clash_empire/Game_exp/Global_Competition.svg'
import Guild_Halls from '../../../assets/Services/Clash_empire/Game_exp/Guild_Halls.svg'
import Power_Heroes from '../../../assets/Services/Clash_empire/Game_exp/Power_Heroes.svg'
import Progressive_Gameplay from '../../../assets/Services/Clash_empire/Game_exp/Progressive_Gameplay.svg'

import API_Integration from '../../../assets/Services/Clash_empire/hood/API_Integration.svg'
import Adaptable_Design from '../../../assets/Services/Clash_empire/hood/Adaptable_Design.svg'
import Analytics_and_Reporting from '../../../assets/Services/Clash_empire/hood/Analytics_and_Reporting.svg'
import Customization from '../../../assets/Services/Clash_empire/hood/Customization.svg'

import Instantaneous_Multiplayer_Assistance from '../../../assets/Services/Clash_empire/hood/Instantaneous_Multiplayer_Assistance.svg'
import Interoperability_across_platforms from '../../../assets/Services/Clash_empire/hood/Interoperability_across_platforms.svg'
import Opportunities_for_Monetization from '../../../assets/Services/Clash_empire/hood/Opportunities_for_Monetization.svg'
import Security_and_Compliance from '../../../assets/Services/Clash_empire/hood/Security_and_Compliance.svg'
import launchingimage from '../../../assets/Launchingimage.png'


const ClashofEmpire = () => {
  const [technical, setTechnical] = useState(true);
  const [Reports, setReports] = useState(false);

  const handleclick = () => {
    setTechnical(true);
    setReports(false);
  };
  const handleclick2 = () => {
    setTechnical(false);
    setReports(true);
  };
 const FeaturesContent = [
  {
    bgColor: "#FFEBDB",
    icon: Guild_Halls,
    title: "Guild Halls",
    desc: `Create and improve guild halls to add features, bonuses, and buffs that improve teamwork.`,
    dataDealy: "0",
  },
  {
    bgColor: "#E0F8F8",
    icon: Power_Heroes,
    title: "Power Heroes",
    desc: `From brave knights and crafty sorcerers, you can choose from them. Watch how they shift the balance in your favor when you send them into combat.`,
    dataDealy: "100",
  },
  {
    bgColor: "#F7EDFF",
    icon: Forging_Alliances,
    title: "Forging Alliances",
    desc: `Attack, share, and strategize with friends to defeat rival kingdoms and win the entire tournament.`,
    dataDealy: "200",
  },
  {
    bgColor: "#FFEBDB",
    icon: Epic_Battles,
    title: "Epic Battles ",
    desc: `Leading your armies, using strong spells, and seeing your forces unite in epic battles are all part of the experience. 
`,
    dataDealy: "0",
  },
  {
    bgColor: "#E0F8F8",
    icon: Progressive_Gameplay,
    title: "Progressive Gameplay",
    desc: `To strengthen your kingdom and gain an advantage, unlock new technology, upgrade buildings, and research spells.`,
    dataDealy: "100",
  },
  {
    bgColor: "#F7EDFF",
    icon: Global_Competition,
    title: "Global Competition",
    desc: `Compete in tournaments and international events to test your abilities and earn prestige and rewards. `,
    dataDealy: "200",
  },
];

  const FeatureContent = [
    {
      icon: White_Label_Solutions,
      title: "White Label Solutions",
      subTitle: `Creates complete brand ownership by customizing every element to produce a gaming experience that reflects your uniqueness.`,
      bgColor: "#FF4A8B",
    },
    {
      icon: Flexible_Licensing_Options,
      title: "Flexible Licensing Options",
      subTitle: `We offer a variety of licensing options to suit your needs and budget. Tell us what you need, and we will find the best solution.`,
      bgColor: "#6D49FF",
    },
    {
      icon: Comprehensive_Support,
      title: "Comprehensive Support",
      subTitle: `Guaranteeing success at every stage of game development, from design to efficient marketing and monetization techniques.`,
      bgColor: "#FFB951",
    },
    {
      icon: Player_profiles_and_customization,
      title: "Player profiles and customization",
      subTitle: `Power up your player’s unique identity and achievements with customized avatars, titles, badges.`,
      bgColor: "#FF4A8B",
    },
    {
      icon: Guilds_and_Alliances,
      title: "Guilds and Alliances",
      subTitle: `Assemble powerful guilds and alliances around players to plan attacks, share the resources, and defeat the enemy together.`,
      bgColor: "#6D49FF",
    },
    {
      icon: Leaderboards_and_Rankings,
      title: "Leaderboards and Rankings",
      subTitle: `Stay ahead on the global leaderboard where everyone can witness your incredible skills and achievements.`,
      bgColor: "#FFB951",
    },
  ];

  const feature = [
    {
      icon:Interoperability_across_platforms ,
      title: " Interoperability across platforms ",
      desc: "The Clash of Empires is optimized for iOS and Android tablets and smartphones. Make connections with other gamers, form a solid team, and take pleasure in a flawless gaming experience.  ",
    },
    {
      icon: Adaptable_Design,
      title: " Adaptable Design ",
      desc: "We create gaming architectures with dynamic load balancing, flexible server infrastructure, and fast growth and high user demand. Our strong and reliable infrastructure supports millions of players.  ",
    },
    {
      icon: Instantaneous_Multiplayer_Assistance,
      title: "Instantaneous Multiplayer Assistance  ",
      desc: " Our real-time battles are devastating and have sophisticated multiplayer support. Our platform offers smooth matchmaking, a strong experience without interfering with network operations, and flawless synchronous gameplay that entices players. ",
    },
    {
      icon: Opportunities_for_Monetization,
      title: " Opportunities for Monetization ",
      desc: " We use advertising, subscriptions, and in-app purchases as monetization techniques. We integrate with leading ad networks and payment gateways to optimize your earnings while rewarding players with engaging gameplay.  ",
    },
  ];

  const feature2 = [
    {
      icon: Analytics_and_Reporting,
      title: " Analytics and Reporting  ",
      desc: " Our platform's robust analytics and reporting features guarantee that you can obtain crucial data about player engagement, behavior, and revenue generation. Make use of real-time data to monitor your progress, identify patterns, and refine your approach. ",
    },
    {
      icon: Security_and_Compliance,
      title: " Security and Compliance  ",
      desc: "Our proactive and cutting-edge security measures will protect both your game and the players. Our durable encryption, secure authentication, and stringent data privacy policies guarantee that players will be in a safe and organized environment.  ",
    },
    {
      icon: API_Integration,
      title: "  API Integration ",
      desc: " We integrate with third-party services and APIs to provide robust functionality across a broad range of integrations, from cloud storage to social media and user authentication, all of which contribute to improving the gaming experience. ",
    },
    {
      icon: Customization,
      title: " Customization  ",
      desc: "  We build a unique gaming infrastructure with UI design, content creation, and feature development, enabling a unique vision to be realized through gaming. We also customize your entire gaming experience to fit your ideas. ",
    },
  ];

  return (
    <>
   <img 
          src={launchingimage} 
          className="Bg-image z-0"
          alt="Launching"
        />
  <div className=" overflow-hidden " >
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />

      <div className="bg-white">
        <div
          className=" container   d-flex align-items-center justify-content-center flex-column "
          style={{ minHeight: "100vh",position:'relative' }}
        >
          <h1 className="h1-heading fw-bold text-center">
            Realm Wars of Clash of Empires{" "}
          </h1>
          <p className="mt-3 h1-para lh-base text-center ">
            {" "}
            Mobile gaming entrepreneurs can reach their full potential by
            removing barriers through support, intelligence, and market tools.
          </p>

          <Link to="/request-quote"> <button className="h3-para btn btn-primary mt-3 py-3 px-3 btn-gradient border-0  rounded-4" style={{ fontSize: 18 }} > Get Your Free Quote </button> </Link>
        </div>
      </div>

      <div className="fancy-feature-twentyTwo mt-80 mart ">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-md-8 m-auto">
              <div className=" text-center ">
                <h2 className="h2-heading mb-md-3 mb-2 pb-2 fw-bold">
                  Emphasis on Features
                </h2>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <FancyFeatureTewentyTwo FeatureContent={FeatureContent} />
          </div>
        </div>
      </div>

      {/* =====================================================
            Feature Blog One
        ===================================================== */}
      <div className="fancy-feature-twentyTwo mt-80 mart ">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-md-8 m-auto">
              <div className=" text-center ">
                <h2 className="h2-heading mb-3 fw-bold">
                  In game{" "}
                  <span className="text-gradient fw-bold">Experience</span>
                </h2>
              </div>
            </div>
          </div>
          <FancyFeatureTen FeaturesContent={FeaturesContent} />
        </div>
      </div>

      <div className="container mt-80 mart">
        <h2 className="h2-heading pb-3 text-center">Under the Hood </h2>
        <p className="h1-para text-center">Every player's smooth gameplay experience is based on our effective and technological requirements. </p>
        <div>
          <div className="d-flex justify-content-evenly mt-3 pt-lg-2">
            <h3
              className={`h3-heading cursor  ${
                technical ? "text-underline-gradient fw-semibold " : "fw-less"
              } `}
              onClick={handleclick}
            >
              Technical Innovation
            </h3>
            <h3
              className={`h3-heading  cursor ${
                Reports ? "text-underline-gradient fw-semibold " : "fw-less"
              } `}
              onClick={handleclick2}
            >
              Reports and Security
            </h3>
          </div>
          <CoreComponentProduct
            technical={technical}
            feature={feature}
            feature2={feature2}
          />
        </div>
      </div>

      <footer className="theme-footer-two pt-80 padt ">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

export default ClashofEmpire;
